/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface DestroyDocumentFolderResponseData
 */
export interface DestroyDocumentFolderResponseData {
  /**
   *
   * @type {boolean}
   * @memberof DestroyDocumentFolderResponseData
   */
  success?: boolean
}

export function DestroyDocumentFolderResponseDataFromJSON(json: any): DestroyDocumentFolderResponseData {
  return DestroyDocumentFolderResponseDataFromJSONTyped(json, false)
}

export function DestroyDocumentFolderResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DestroyDocumentFolderResponseData {
  if (json === undefined || json === null) {
    return json
  }
  return {
    success: !exists(json, 'success') ? undefined : json['success']
  }
}

export function DestroyDocumentFolderResponseDataToJSON(value?: DestroyDocumentFolderResponseData | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    success: value.success
  }
}
